import { createSwiperProductBlocks } from './base'
import { handleFreeShipping } from './global'

export function initAdvancedOrder() {
    document.addEventListener('ShoptetDOMAdvancedOrderLoaded', () => {
        updateButtonText()
        handleFreeShipping()
        addExtras()

        setTimeout(() => {
            addProductsHeader()
            createSwiperProductBlocks('.advanced-order .products-wrapper')
            $('.advanced-order .swiper-products-container').show()
        }, 200)
    })
}

function updateButtonText() {
    $('.advanced-order .advancedOrder__buttons .next-step-back').text('Weiter einkaufen');
    $('.advanced-order .advancedOrder__buttons .btn-conversion').text('Warenkorb anzeigen');
}

function addProductsHeader() {
    $('.advanced-order .products-wrapper').before(
        '<div class="homepage-group-title homepage-products-heading-2 h4">Das könnte Ihnen auch gefallen</div>'
    );
}

function addExtras() {
    $('.extras-wrap').append(`
<!--        <div class="extra gift">-->
<!--          <span>-->
<!--            <strong>Získejte 11,9 izoláčků&nbsp;</strong> v rámci&nbsp;<a href="#">bonusového programu.</a>&nbsp;Stačí se&nbsp;<a href="/login">přihlásit</a>&nbsp;nebo&nbsp;<a href="/registrace">zaregistrovat</a>.-->
<!--          </span>-->
<!--        </div>-->
<!--        <div class="extra paint">-->
<!--          <span>-->
<!--            <strong>Chcete vymalovat?&nbsp;</strong>Nabízíme profesionální aplikaci ABAMALu.&nbsp;<a href="/nezavazna-poptavka">Nezávazně poptat</a>-->
<!--          </span>-->
<!--        </div>-->
    `);
}